<template>
  <div>
    <v-data-table
      :loading="isEmpty(items.schema)"
      loading-text="Loading..."
      :headers="headers"
      :items="items.data"
      :items-per-page="-1"
      class="text-truncate"
      dense
      disable-filtering
      disable-sort
      hide-default-footer
    />
    <span v-intersect="onIntersect"></span>
  </div>
</template>
<script>
export default {
  props: {
    items: { type: Object, required: true }
  },
  data() {
    return {
      headers: [],
    }
  },
  watch: {
    items: {
      deep: true, 
      handler() {
        if ('fields' in this.items.schema) {
          this.populateHeaders(this.items.schema.fields)
        }
      }
    }
  },
  mounted() {
    if ('fields' in this.items.schema) {
      this.populateHeaders(this.items.schema.fields)
    }
  },
  methods: {
    populateHeaders(fields) {
      this.headers = []
      fields.forEach((val, key, arr) => {
        if (Object.is(arr.length - 1, key)) {
          this.headers.push({ text: val.name.toUpperCase(), value: val.name, width: "99%" })
        } else {
          if (val.name == "index") this.headers.push({ text: "#", value: val.name, width: "1%" })
          else this.headers.push({ text: val.name.toUpperCase(), value: val.name, width: "1%" })
        }
      })
    },
    onIntersect(entries, observer) {
      if (!!entries[0].isIntersecting) {
        this.$emit("load")
      }
    },
  }
}
</script>
